import type { Language } from '../types/document'
import type { ChromeCopy } from './chrome/types'
import { hi } from './chrome/hi'
import { en } from './chrome/en'
import { bn } from './chrome/bn'
import { mr } from './chrome/mr'
import { ta } from './chrome/ta'
import { te } from './chrome/te'
import { gu } from './chrome/gu'
import { kn } from './chrome/kn'
import { ml } from './chrome/ml'
import { pa } from './chrome/pa'
import { or } from './chrome/or'
import { asm } from './chrome/as'

// App frame text (header, Saved, Info, offline banner) in every supported
// language. The document explanation itself lives in ./packs.
const CHROME: Record<Language, ChromeCopy> = { hi, en, bn, mr, ta, te, gu, kn, ml, pa, or, as: asm }

export const CONTACT_EMAIL = 'swayamgupta999@gmail.com'

export type Copy = ChromeCopy
export const t = (language: Language): Copy => CHROME[language] ?? hi
